import { render, staticRenderFns } from "./FoodForm.vue?vue&type=template&id=52787458&scoped=true&"
import script from "./FoodForm.vue?vue&type=script&lang=js&"
export * from "./FoodForm.vue?vue&type=script&lang=js&"
import style0 from "./FoodForm.vue?vue&type=style&index=0&id=52787458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52787458",
  null
  
)

export default component.exports